import React from 'react';
import { Badge } from '@myua/kit';
import { getData } from '../selectors';
import { useSelector } from 'react-redux';

export const PackBadge: React.FC = ({ children }) => {
  const { total } = useSelector(getData);

  return (
    <Badge count={total.read.count} overflowCount={99} size="small" className="al-pack-badge-count">
      {children}
    </Badge>
  );
};
